import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCheckAdmin, useCheckAuth } from "../../Query/useAuth";
import SplashScreen from "./SplashScreen";
import { useMyself } from "../../Query/useUsers";

type WithAuthProps<P = object> = {
  Component: React.ComponentType<P>;
  fallbackPath: string;
  admin?: boolean;
};

const withAuth = ({
  Component,
  fallbackPath,
  admin = false,
}: WithAuthProps) => {
  const WrappedComponent: React.FC<React.ComponentProps<typeof Component>> = (
    props
  ) => {
    const navigate = useNavigate();
    const myselfQuery = useMyself();

    const checkAuthQuery = useCheckAuth({
      enabled: !admin,
    });

    const checkAdminQuery = useCheckAdmin({
      enabled: admin,
    });

    useEffect(() => {
      if (!admin && checkAuthQuery.isError) {
        navigate(fallbackPath);
      }
    }, [checkAuthQuery.isError, navigate]);

    useEffect(() => {
      if (admin && checkAdminQuery.isError) {
        navigate(fallbackPath);
      }
    }, [checkAdminQuery.isError, navigate]);

    if (!admin && checkAuthQuery.isSuccess && !myselfQuery.isLoading) {
      return <Component {...props} />;
    }

    if (admin && checkAdminQuery.isSuccess && !myselfQuery.isLoading) {
      return <Component {...props} />;
    }

    return <SplashScreen />;
  };

  WrappedComponent.displayName = `withAuth(${
    Component.displayName || Component.name || "Component"
  })`;

  return <WrappedComponent />;
};

export default withAuth;
